module.exports = __webpack_public_path__ + "static/media/boatg.3061196d.gif";